//see MisName.cs for more info
export enum MisName
{
    "arbor"="arbor",
    "bromcom"="bromcom",
    "isams"="isams",
    "sims"="sims",
    
    "salamanderSql"="salamanderSql",
    "go4schools"="go4schools",
    "schoolBase"="schoolBase",
    "wonde"="wonde",
    "rems"="rems",
    "manageBac"="manageBac",
    "engage"="engage",
    "proSolution"="proSolution",
    "compass"="compass",
    "pass"="pass",
}
